import React from "react"
import {
  ART_PIECE_TAG_MEDIUM,
  ART_PIECE_TAG_STYLE,
  ART_PIECE_TAG_SUBJECT,
} from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"

const ArtPieceSharedDetails = () => {
  return (
    <>
      <AsyncCreatableTag
        name="shrStyle"
        group={ART_PIECE_TAG_STYLE}
        label="Style"
      />
      <AsyncCreatableTag
        name="shrSubject"
        group={ART_PIECE_TAG_SUBJECT}
        label="Subject"
      />
      <AsyncCreatableTag
        name="shrMedium"
        group={ART_PIECE_TAG_MEDIUM}
        label="Medium"
      />
      <FormInput name="shrSeries" label="Series" />
      <FormInput name="shrCollection" label="Collection" />
    </>
  )
}

export default ArtPieceSharedDetails
